import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-inline-select',
    templateUrl: './inline-select.component.html',
    styleUrls: ['./inline-select.component.scss'],
    standalone: false
})
export class InlineSelectComponent implements OnInit {
  @Input() label: string;
  @Input() data: {
    value: string,
    label: string
  } = null;
  @Input() disabledFlag: boolean;
  @Input() defaultPlaceHolder: string;
  @Input() items: {
    value: string,
    label: string
  }[] = [];
  @Output() focusOut: EventEmitter<{
    value: string,
    label: string
  }> = new EventEmitter<{
    value: string,
    label: string
  }>();

  tempValue: string;

  editMode = false;

  initialValue: {
    value: string,
    label: string
  } = null;

  constructor() {}

  ngOnInit() {
    this.initialValue = this.data;
    this.tempValue = this.data.value;
  }
  onFocusOut() {
    this.editMode = false;
    this.data = this.items.find(item => {
      return item.value === this.tempValue;
    });
    this.focusOut.emit( this.data );
  }
  editOff() {
    this.editMode = false;
  }

  undo() {
    this.editMode = false;
    this.data = this.initialValue;
    this.focusOut.emit( this.data );
  }
}
